import { ActionModel } from './action.model';
import { ReferenceModel } from './reference.model';
import { UserModel } from './user.model';
import { BuildingModel } from './building.model';
import { DiagnosticModel } from './diagnostic.model';
import { AnswerModel } from './answer.model';
import { SimpleAnswerModel } from './simpleAnswer.model';




export class ObjectifModel
{
	id: number = undefined;
	name:string = undefined;
	redaction:string = undefined;
	start: string = undefined;
	end: string = undefined;
	budget: number = undefined;
	ratio: string = undefined;
	status: number = undefined; /*0:TODO,1:Work in progress, 2:finished, 3:achieved,-1:canceled*/

	building: BuildingModel = new BuildingModel({});
	answer:SimpleAnswerModel = new SimpleAnswerModel({});
  diagnostic:DiagnosticModel = new DiagnosticModel({});
	actions:Array<ActionModel> = [];
	references:Array<ReferenceModel> = [];

  origUsers:Array<UserModel> = [];
  currentUsers:Array<UserModel> = [];

  //app only, not property
  showIndicator:boolean = false;

	constructor(values) {
		this.exchange(values, false);
	}
	
	exchange(values: Object = {}, isObject=false) {
	    for (let p in values) {
	    	
		    if (this.hasOwnProperty(p) && values.hasOwnProperty(p)) {
		    	if(p == 'id' && this.id != undefined) {
		    		continue;
		    	}
	          	else if(p=='start' || p=='end') {
	            	if(values[p]!=null) this[p] = values[p].date.split(' ')[0];
	          	}
	          	else if(p=='actions' || p=='references' || p=='users') {}
		    	else {
		    		if(isObject) this[p].exchange(values[p]);
		    		else this[p] = values[p];
		    	} 
		    }
		    else if(p=='_embedded') {
	    		this.setEmbedded(values[p]);
	    	}
		}
	}

	setEmbedded(values)
	{
		if(values.building) this.building.exchange(values.building);
		if(values.answer) this.answer.exchange(values.answer);
	}




  get users()
  {
    return this.currentUsers;
  }
  set users(u:Array<UserModel>)
  {
    this.currentUsers = u;
  }
  get user_add()
  {
    let add = [];
    this.currentUsers.forEach((user:UserModel)=>{
      if(!this.origUsers.includes(user))
        add.push(user.id);
    });
    return add;
  }
  get user_remove()
  {
    let remove = [];
    this.origUsers.forEach((user:UserModel)=>{
      if(!this.currentUsers.includes(user))
        remove.push(user.id);
    });
    return remove;
  }

  export()
  {
    return {
      id: this.id,
      name: this.name,
      redaction: this.redaction,
      start: this.start,
      end: this.end,
      budget: this.budget,
      ratio: this.ratio,
      status: this.status,
      user_add: this.user_add,
      user_remove: this.user_remove,
      building: this.building.id,
      answer: this.answer ? this.answer.id : null,
      diagnostic: this.diagnostic ? this.diagnostic.id : null
    }
  }
}